import { Component } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '.../../environments/environment'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core'
import { MomentDateAdapter } from '@angular/material-moment-adapter'
import { utils, write, WorkBook } from 'xlsx'
import { saveAs } from 'file-saver'
import { AuthService } from '../../_services'
import { process, State, aggregateBy } from '@progress/kendo-data-query'
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query'
import { Observable } from 'rxjs/Observable'
import {
  SelectableSettings,
  DataStateChangeEvent,
  GridDataResult,
} from '@progress/kendo-angular-grid'
import { LoaderService } from '../../_services/loader.service'
import Swal from 'sweetalert2'
import * as _moment from 'moment'
import * as _rollupMoment from 'moment'
const moment = _rollupMoment || _moment
import { ThemePalette } from '@angular/material/core'

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'ucc-DashBoard',
  templateUrl: './uccDashboard.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class UccDashboardComponent {
  dailyUccCollection = []
  dailyCollection: any
  dashboardCard: any
  yesterdayData: any
  public value: number = 10
  todayDataUcc: any
  arrowUp: any
  percentInc: any
  percentDec: any
  amountMtd: any
  householdMtd: any
  topPerformerName: any
  topPerformerAmount: any
  uccCollector: any
  labelContent: any
  public netWeight = 0
  public totalCNT = 0
  public total = 0
  public totalPending = 0
  public totalResolved = 0
  public prjcd: any
  public totalToday = 0
  public totalPendingToday = 0
  public totalResolvedToday = 0
  public totalMTD = 0
  public totalPendingMTD = 0
  public totalResolvedMTD = 0
  public startDateMTD: any
  public todayFeedBack = 0
  public todayObser = 0
  public today: any
  complainData: any
  complainDataList: any
  defaultStartDate: any
  defaultEndDate: any
  dateRangeModal: any
  public todayData: any
  public customData: any
  public mtdData: any
  prjId: any
  totalComplain: any
  todayTotal: any
  totPending: any
  totResolved: any
  public totalCustFeedBack = 0
  public totalCustUnderOb = 0
  complainChartList: any
  public startDate: any
  public endDate: any
  dataNotFound = false
  chartNotFound = false
  public showLoader: boolean
  customDataNotFound = false
  customChartNotFound = false
  custMtdFeedBack = 0
  custMtdUnderObser = 0
  public aggregates: any[] = [
    { field: 'Total', aggregate: 'sum' },
    { field: 'Today', aggregate: 'sum' },
    { field: 'Pending', aggregate: 'sum' },
    { field: 'Resolved', aggregate: 'sum' },
    { field: 'FeedBack', aggregate: 'sum' },
    { field: 'UnderObservation', aggregate: 'sum' },
  ]
  public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  public pageSize: any
  public checkboxOnly = false
  public mode = 'multiple'
  public selectableSettings: SelectableSettings
  public groups: GroupDescriptor[] = []
  public view: Observable<GridDataResult>
  public gridCollectorData: DataResult
  public gridZoneData: DataResult
  public gridDayData: DataResult
  public gridCollectorDataNull: DataResult

  zoneWiseHousehold: boolean
  zoneWiseCollection: boolean
  ZonehhOnly: boolean
  ZoneuccOnly: boolean
  ZonehhAnducc: boolean

  dayWiseHousehold: boolean
  dayWiseCollection: boolean
  DayWisehhOnly: boolean
  DayWiseuccOnly: boolean
  DayWisehhAnducc: boolean
  isLoadedZone: boolean = false
  isLoaded: boolean = false
  public isLoadedDay: boolean = false
  isLoadedKCC: boolean = false
  isLoadedCards: boolean = false
  yesterdayTotal: any
  nullZoneData = []
  todayAmount: any
  yesterdayAmount: any
  percentIncAmt: number
  percentDecAmt: number
  arrowUpAmt: boolean
  maxAxis: any
  minAxis = 0
  amountArray = []
  totalHouseArray = []
  dateArray = []
  zoneWiseAmountArray = []
  zoneWiseTotalHouseArray = []
  zonesArray = []
  queryType: string = 'ZoneWise'
  tableName: string = 'Zone wise'
  totalKccAmount: any
  totalKccList: any
  hasNoUccData: boolean
  checkdate: boolean

  public primeDroupdownModal = 'Months'
  yearsModal: any
  monthsmodal: any
  selectedStartsDate: string
  selectedEndDate: string
  currentMonth: string

  public currentMonthStatus = true

  public globleStartDate

  public globleEndDate

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }
  public complainTypeData: any
  public complainZoneWiseData: any
  public complainMonthWiseData: any
  private loadProducts(): void {
    this.gridCollectorData = process(this.uccCollector, { group: this.groups })
    this.gridZoneData = process(this.dailyUccCollection, { group: this.groups })
    this.gridDayData = process(this.dailyCollection, { group: this.groups })
    this.gridCollectorDataNull = process(this.nullZoneData, {
      group: this.groups,
    })
  }

  // day wise
  public series: any[] = [
    {
      type: 'line',
      data: [],
      name: 'Total Household',
      color: '#4e4141',
      axis: 'hh',
    },
    {
      type: 'column',
      data: [],
      name: 'UCC Collection',
      color: '#ec5e0a',
      axis: 'amount',
    },
  ]

  public valueAxes: any[] = [
    {
      name: 'hh',
      title: 'Total household covered',
      color: '#4e4141',
      position: 'end',
    },
    {
      name: 'amount',
      title: 'Total UCC Collection',
      color: '#ec5e0a',
      position: 'start',
    },
  ]

  public categories: string[] = []

  // zone wise
  public zoneWiseSeries: any[] = [
    {
      type: 'line',
      data: [],
      name: 'Total Household',
      color: '#4e4141',
      axis: 'hh',
    },
    {
      type: 'column',
      data: [],
      name: 'UCC Collection',
      color: '#ec5e0a',
      axis: 'amount',
    },
  ]

  public zoneWiseValueAxes: any[] = [
    {
      name: 'hh',
      title: 'Total household covered',
      color: '#4e4141',
      position: 'end',
    },
    {
      name: 'amount',
      title: 'Total UCC Collection',
      color: '#ec5e0a',
      position: 'start',
    },
  ]

  public zoneWiseCategories: string[] = []

  entityType = [
    { id: 1, name: 'Zone Wise', value: 'ZoneWise' },
    { id: 2, name: 'Ward Wise', value: 'WardWise' },
  ]

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private loaderService: LoaderService,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    this.defaultStartDate =
      firstDay.getFullYear() +
      '-' +
      (firstDay.getMonth() + 1) +
      '-' +
      firstDay.getDate()
    this.defaultEndDate =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    this.dateRangeModal = {
      beginDate: {
        year: firstDay.getFullYear(),
        month: firstDay.getMonth() + 1,
        day: firstDay.getDate(),
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    }
    this.startDateMTD =
      firstDay.getFullYear() +
      '-' +
      (firstDay.getMonth() + 1) +
      '-' +
      firstDay.getDate()
    this.today =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  }

  getKccData(fromDate, toDate) {
    this.isLoadedKCC = true

    var apiUrl =
      environment.apiUrl +
      'payment/getTotalKCCAmount?prjId=' +
      this.prjId +
      '&fromDt=' +
      fromDate +
      '&toDt=' +
      toDate

    this.loaderService.display(true)
    this.http.get(apiUrl).subscribe((data) => {
      var result: any
      result = data
      if (result.length > 0) {
        this.totalKccAmount = Number(result[0].TOTALKCC).toLocaleString('en-IN')
        this.isLoadedKCC = false
      } else {
        this.totalKccAmount = 0
        this.isLoadedKCC = false
      }
    })
  }

  // Zone wise collection
  uccDailyCollectionEntityWise(stdate, enddate) {
    this.clearDataZoneWise()
    this.isLoadedZone = true
    var zoneName
    var zoneNumber

    this.http
      .get(
        environment.apiUrl +
          'ucc/uccDailyCollectionEntityWise?prjId=' +
          this.prjId +
          '&queryType=' +
          this.queryType +
          '&fromDate=' +
          stdate +
          '&toDate=' +
          enddate,
      )
      .subscribe((data) => {
        var zonewisedata: any
        zonewisedata = data
        for (var i = 0; i < zonewisedata.length; i++) {
          if (zonewisedata[i].EntityName != null) {
            this.dailyUccCollection.push(zonewisedata[i])
            this.gridZoneData = process(this.dailyUccCollection, this.state)
          } else {
            this.nullZoneData.push(zonewisedata[i])
            this.gridCollectorDataNull = process(this.nullZoneData, this.state)
          }

          zoneName = this.dailyUccCollection[i].EntityName.substring(0, 1)
          zoneNumber = this.dailyUccCollection[i].EntityName.substring(
            this.dailyUccCollection[i].EntityName.lastIndexOf('-') + 0,
          )
          zoneName += zoneNumber

          this.zoneWiseAmountArray.push(this.dailyUccCollection[i].Amount)
          this.zoneWiseTotalHouseArray.push(
            this.dailyUccCollection[i].TotalHouseholds,
          )
          this.zonesArray.push(zoneName)
        }
        this.zoneWiseSeries[0].data = this.zoneWiseTotalHouseArray
        this.zoneWiseSeries[1].data = this.zoneWiseAmountArray
        this.zoneWiseCategories = this.zonesArray
        this.isLoadedZone = false
      })
  }

  // day wise collection
  uccDailyCollection(stdate, enddate) {
    this.clearDataDayWise()
    this.isLoadedDay = true

    // this.checkdate = true ;

    let MMdate = moment().format('YYYY-MM-DD')

    if (enddate == MMdate) {
      this.checkdate = true
    } else {
      this.checkdate = false
    }

    this.http
      .get(
        environment.apiUrl +
          'ucc/uccDailyCollection?prjId=' +
          this.prjId +
          '&fromDate=' +
          stdate +
          '&toDate=' +
          enddate,
      )
      .subscribe((data) => {
        this.dailyCollection = data
        this.bindCard(this.dailyCollection)

        this.isLoadedDay = false

        for (let i = 0; i < this.dailyCollection.length; i++) {
          this.gridDayData = process(this.dailyCollection, this.state)

          let date = this.dailyCollection[i].date

          let dayOnly = date.substring(0, 2)
          this.dailyCollection[i].dateAndMonth = dayOnly
          this.amountArray.push(this.dailyCollection[i].amount)
          this.totalHouseArray.push(this.dailyCollection[i].total)
          this.dateArray.push(this.dailyCollection[i].date.substring(0, 2))
        }
        this.series[0].data = this.totalHouseArray
        this.series[1].data = this.amountArray
        this.categories = this.dateArray
      })
  }

  queryFilter(data) {
    this.queryType = null
    if (data == null) {
      this.queryType = 'ZoneWise'
      this.tableName = 'Zone wise'
    } else {
      this.queryType = data.value
      if (this.queryType == 'ZoneWise') {
        this.tableName = 'Zone wise'
      } else {
        this.tableName = 'Ward wise'
      }
    }

    this.uccDailyCollectionEntityWise(this.globleStartDate, this.globleEndDate)
  }

  clearDataDayWise() {
    this.dailyCollection = null
    this.totalHouseArray = []
    this.amountArray = []
    this.dateArray = []
    this.series[0].data = []
    this.series[1].data = []
    this.categories = []
  }

  clearDataZoneWise() {
    this.dailyUccCollection = []
    this.zoneWiseTotalHouseArray = []
    this.zoneWiseAmountArray = []
    this.zonesArray = []
    this.zoneWiseSeries[0].data = []
    this.zoneWiseSeries[1].data = []
    this.zoneWiseCategories = []
  }

  // top collector
  //  getTopPerformer() {
  //   let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
  //   let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');
  //   this.http.get(environment.apiUrl + 'ucc/topPerformer?prjId=' + this.prjId + "&fromDate=" + stdate + "&toDate=" + enddate).subscribe(data => {
  //     var topPerformer = data[0]
  //     this.topPerformerName = topPerformer.collectorName
  //     this.topPerformerAmount = topPerformer.amount
  //   })
  // }

  // collection and hh by Collector name
  collectionBycollectorName(stdate, enddate) {
    this.uccCollector = null
    this.isLoaded = true
    // let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD')
    // let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD')
    this.http
      .get(
        environment.apiUrl +
          'ucc/collectionBycollectorName?prjId=' +
          this.prjId +
          '&fromDate=' +
          stdate +
          '&toDate=' +
          enddate,
      )
      .subscribe((data) => {
        this.uccCollector = data
        this.gridCollectorData = process(this.uccCollector, this.state)
        this.isLoaded = false
      })
  }

  importUccMobileReport(data) {
    const ws_name = 'importUccMobileReport'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(data)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'uccReport.xlsx',
    )
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }

  bindCard(data) {
    if (data.length >= 2) {
      this.yesterdayData = data[data.length - 2]
      this.yesterdayTotal = this.yesterdayData.total
      this.yesterdayAmount = this.yesterdayData.amount
    }

    this.todayDataUcc = data[data.length - 1]

    this.todayTotal = this.todayDataUcc.total
    this.todayAmount = this.todayDataUcc.amount

    var householdMtd = 0
    var amountMtd = 0

    for (var i = 0; i < data.length; i++) {
      householdMtd = householdMtd + data[i].total
      amountMtd = amountMtd + data[i].amount
    }

    this.householdMtd = householdMtd
    this.amountMtd = amountMtd

    if (this.yesterdayAmount == 'N/A') {
      this.percentInc = 'N/A'
      this.arrowUp = true
    } else if (this.todayAmount > this.yesterdayAmount) {
      this.percentInc =
        (this.todayAmount - this.yesterdayAmount) / this.yesterdayAmount
      this.arrowUp = true
    } else {
      this.percentDec =
        (this.yesterdayAmount - this.todayAmount) / this.yesterdayAmount
      this.arrowUp = false
    }

    if (this.yesterdayTotal == 'N/A') {
      this.percentInc = 'N/A'
      this.arrowUp = true
    } else if (this.todayTotal > this.yesterdayTotal) {
      this.percentIncAmt =
        (this.todayTotal - this.yesterdayTotal) / this.yesterdayTotal
      this.arrowUpAmt = true
    } else {
      this.percentDecAmt =
        (this.yesterdayTotal - this.todayTotal) / this.yesterdayTotal
      this.arrowUpAmt = false
    }

    // var YesterdayDate = moment(moment().subtract(1, 'day')).format('YYYY-MM-DD')

    // this.isLoadedCards = true
    // if (data.length > 0) {
    //   this.hasNoUccData = false

    //   this.yesterdayData = data[data.length - 2]
    //   this.todayDataUcc = data[data.length - 1]

    //   console.log('this.yesterdayData', this.yesterdayData)

    //   this.todayTotal = this.todayDataUcc.total
    //   this.todayAmount = this.todayDataUcc.amount

    //   let MMdate = moment().format('DD-MM-YYYY')

    //   if (this.checkdate) {
    //     if (MMdate == this.todayDataUcc.date) {
    //       this.todayTotal = this.todayDataUcc.total
    //       this.todayAmount = this.todayDataUcc.amount
    //     } else {
    //       this.todayTotal = 0
    //       this.todayAmount = 0
    //     }
    //   }
    //   if (YesterdayDate == this.yesterdayData.date) {
    //     if (this.yesterdayData) {
    //       this.yesterdayTotal = this.yesterdayData.total
    //       this.yesterdayAmount = this.yesterdayData.amount
    //     } else {
    //       this.yesterdayTotal = 'N/A'
    //       this.yesterdayAmount = 'N/A'
    //     }
    //   }

    //   var householdMtd = 0
    //   var amountMtd = 0
    //  for (var i = 0; i < data.length; i++) {
    //     householdMtd = householdMtd + data[i].total
    //     amountMtd = amountMtd + data[i].amount
    //   }
    //   this.householdMtd = householdMtd
    //   this.amountMtd = amountMtd
    //   this.isLoadedCards = false
    // } else {
    //   this.todayTotal = 0
    //   this.todayAmount = 0
    //   this.percentIncAmt = 0
    //   this.percentDecAmt = 0
    //   this.householdMtd = 0
    //   this.yesterdayTotal = 0
    //   this.yesterdayAmount = 0
    //   this.percentInc = 0
    //   this.percentDec = 0
    //   this.amountMtd = 0
    //   this.hasNoUccData = true
    //   this.isLoadedCards = false
    // }
  }

  // filter The Grid Data
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    this.gridCollectorData = process(this.uccCollector, this.state)
    this.gridZoneData = process(this.dailyUccCollection, this.state)
    this.gridDayData = process(this.dailyCollection, this.state)
    this.gridCollectorDataNull = process(this.nullZoneData, this.state)
    if (state && state.group) {
      this.gridCollectorData = process(this.uccCollector, this.state)
      this.gridZoneData = process(this.dailyUccCollection, this.state)
      this.gridDayData = process(this.dailyCollection, this.state)
      this.gridCollectorDataNull = process(this.nullZoneData, this.state)
    }
  }

  // Filter Data details
  onDateRangeChanged(dateRange) {
    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate =
        dateRange.beginDate.year +
        '-' +
        dateRange.beginDate.month +
        '-' +
        dateRange.beginDate.day
      this.defaultEndDate =
        dateRange.endDate.year +
        '-' +
        dateRange.endDate.month +
        '-' +
        dateRange.endDate.day
      //this.uccDailyCollectionEntityWise(stdate,enddate)

      //this.uccDailyCollectionEntityWise()

      //this.uccDailyCollection()
      //this.collectionBycollectorName()
      //this.getKccData()
      // this.getTopPerformer()
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
      // this.uccDailyCollectionEntityWise(stdate,enddate)
      //this.uccDailyCollection()
      // this.collectionBycollectorName()
      //this.getKccData()
      // this.getTopPerformer()
    }
  }

  ngOnInit(): void {
    var ss = window.location.pathname.split('/')
    this.prjcd = ss[2]
    this.prjId = this.auth.getAuthentication().projectId

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD')
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD')

    this.globleStartDate = stdate

    this.globleEndDate = enddate

    this.uccDailyCollectionEntityWise(stdate, enddate)
    this.uccDailyCollection(stdate, enddate)
    this.getKccData(stdate, enddate)
    // this.getTopPerformer()
    this.collectionBycollectorName(stdate, enddate)
  }

  changeYearsForGraph(e) {
    this.yearsModal = e.target.value
    this.monthsmodal = null
  }

  changecDateForGraph(e) {
    this.selectedEndDate = null

    var months = e.target.value
    var currMonthName = moment().format('MM')

    if (this.yearsModal == 'undefined' || this.yearsModal == undefined) {
      alert('Please Select Years')

      return false
    }

    if (Number(months) === Number(currMonthName)) {
      this.currentMonthStatus = true
    } else {
      this.currentMonthStatus = false
    }

    var lastday = function (y, m) {
      return new Date(y, m, 0).getDate()
    }

    this.selectedStartsDate = this.yearsModal + '-' + months + '-01'
    this.selectedEndDate =
      this.yearsModal + '-' + months + '-' + lastday(this.yearsModal, months)
    this.currentMonth = moment(this.selectedStartsDate).format('MMMM')

    this.globleStartDate = this.selectedStartsDate

    this.globleEndDate = this.selectedEndDate

    this.collectionBycollectorName(
      this.selectedStartsDate,
      this.selectedEndDate,
    )

    this.getKccData(this.selectedStartsDate, this.selectedEndDate)

    this.uccDailyCollectionEntityWise(
      this.selectedStartsDate,
      this.selectedEndDate,
    )

    this.uccDailyCollection(this.selectedStartsDate, this.selectedEndDate)
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/uccReport/uccDashboard.component.ts